import Konva from "konva";

class Popup {

    /**
     * Create new popup on canvas
     * @param {ConfiguratorCanvas} configurator.
    * */
    constructor(configurator) {
        this.configurator = configurator;
        this.sofa = configurator.sofa;
        this.configData = this.sofa.configData;
        this.hasInstance = false;
    }

    /*построение попапа*/
    buildPopup(position, id, index, remove = false) {

        let object = this;

        let scale = object.sofa.group.scaleX();
        let scaleShift = scale/(scale*scale);
        this.x = position.x;
        this.y = position.y;
        let helpCondition = false;

/*        console.log('//////////////////////////////////////////////////////////////');
        console.log('object.sofa.state.length > 1', object.sofa.state.length > 1);
        console.log('object.configData.sections[object.sofa.currentSofa][id].isAngle', object.configData.sections[object.sofa.currentSofa][id].isAngle);
        console.log('object.sofa.anglesCount === 1', object.sofa.anglesCount === 1);
        console.log('object.sofa.state[index].position === \'front\'', object.sofa.state[index].position === 'front');
        console.log('helpCondition', helpCondition);*/

        /*Группа попапа*/
        let popup = new Konva.Group({
            x: object.x - (34 * scaleShift),
            y: object.y - (38 * scaleShift),
            scaleX: scaleShift,
            scaleY: scaleShift,
            width: 68,
            height: 38,
            name: 'popup'
        });

        /*Крестик закрытия*/
        let crossImage = object.configData.cross;
        let cross = new Konva.Image({
            x: 37,
            y: 2,
            width: 33,
            height: 30,
            image: false,
            fillPatternX: 7,
            fillPatternY: 7,
            fillPatternRepeat: 'no-repeat',
            fillPatternScale: {x:0.68, y:0.68},
            fillPatternImage: crossImage,
            name: 'popupCross'
        });

        /*Разделитель*/
        let delimiter = new Konva.Line({
            points: [36, 6, 36, 26],
            stroke: '#DADADA',
            strokeWidth: 1,
            closed: false,
            name: 'popupDelimiter'
        });

        let infoX = 10;
        let infoY = 9;
        let infoWidth = 33;
        let scaleX = 0.55;
        let scaleY = 0.55;
        if(remove === false) {
            infoX = 27;
            infoY = 9;
            scaleX = 0.25;
            scaleY = 0.55;
            infoWidth = 68;
        }

        /*"i" в кружочке*/
        let infoImage = object.configData.info;
        let info = new Konva.Image({
            x: infoX,
            y: infoY,
            width: infoWidth,
            height: 30,
            image: infoImage,
            scale: {x: scaleX, y: scaleY},
            name: 'popupInfo'
        });

        /*фон*/
        let popupBgImage = object.configData.popupBg;
        let popupBg = new Konva.Image({
            x: -2,
            y: -2,
            width: 75,
            height: 45,
            image: popupBgImage,
            name: 'popupBg'
        });

        // console.log('remove', remove);

        if(!object.hasInstance === true) {
            if(remove !== false) {
                popup.add(popupBg);
                popup.add(cross);
                popup.add(delimiter);
                popup.add(info);
            }
            else {
                popup.add(popupBg);
                popup.add(info);
            }

            object.initEvents(cross, info, id, remove);

            object.sofa.group.add(popup);

            object.hasInstance = true;

            object.configurator.layer.draw();
        }
    }

    /*Подключение событий*/
    initEvents(cross, info, id, remove) {
        let object = this;

        if(remove !== false) {
            cross.on('click touchstart', function () {
                object.sofa.helpers.processChairPosition(object.sofa.state[remove], object.sofa, true);
                object.sofa.state.splice(remove, 1);
                object.sofa.rebuild();
                object.configurator.callSofaMethods();
                object.configurator.layer.draw();
            });
        }

        info.on('click touchstart', function () {
            let place = $('#popup-place');
            let infoPopup = $('.info-popup').clone();
            let section = object.configData.sections[0][id];

            let imageSrc = section['popupImg'];
            let title = section['name'];
            let sizes = section['sizes']['x'] + ' x ' + section['sizes']['y'] + ' x ' + section['sizes']['z'];
            let price = $('.js-configurator-module[data-id=' + id + ']').data('price');
            let currency = object.configData.translatedPhrases['грн'];

            infoPopup.find('.js-info-popup-title').text(title);
            infoPopup.find('.js-info-popup-sizes').text(sizes);
            infoPopup.find('.js-info-popup-image').attr('src', imageSrc);
            infoPopup.find('.js-info-popup-price').text(object.sofa.helpers.formattedPrice(price));
            infoPopup.find('.js-info-popup-currency').text(currency);

            place.append(infoPopup);
            place.addClass('active');

            let close = infoPopup.find('.js-info-popup-close');

            close.on('click', function () {
                place.children().remove();
                place.removeClass('active')
            });
        })
    }

    /*Убрать попап*/
    destroy() {
        let object = this;
        let popup = object.sofa.group.find('.popup');

        popup.find('.popupCross').remove();
        popup.find('.popupDelimiter').remove();
        popup.find('.popupInfo').remove();
        popup.find('.popupBg').remove();
        popup.remove();

        object.hasInstance = false;
    }
}

export default Popup;
